import stringToFloat from 'functions/string-to-float'

const serializeObject = (form, opts = {}, seperator = ',') => {
	return new Promise((resolve) => {
		let asyncElems = 0;
		let defaultOpts = {
			ignoreEmpty: false,
			multipleString: false,
			multipleStringSeperator: ',',
			parseBool: true,
		}

		opts = {...defaultOpts, ...opts};

		let serialized = {};
		let elements = (form.elements ? form.elements : form.querySelectorAll('input, textarea, select'));
		for (let i = 0; i < elements.length; i++) {

			let field = elements[i];

			if (!field.name || field.disabled /*|| field.type === 'file'*/ || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

			if (field.type === 'select-multiple') {
				for (let n = 0; n < field.options.length; n++) {
					if (!field.options[n].selected) continue;
					let val = field.options[n].value;
					if(opts.parseBool && (val === 'true' || val === 'false')){
						val = (val === 'true');
					}

					if (!(opts.ignoreEmpty && val === '')) {
						let name = field.name.replace('[]', '');
						if (serialized[name] && name + '[]' === field.name) {
							if(opts.multipleString) {
								val = serialized[name] += opts.multipleStringSeperator + val;
							}
							else {
								let nval = serialized[name];
								nval.push(val);
								val = nval;
							}
						}
						serialized[name] = val;
					}
				}
			}
			else if (((field.type !== 'checkbox' && field.type !== 'radio') && opts.parseBool) || field.checked) {
				let val = field.value;

				if((field.type === 'checkbox' || field.type === 'radio') && !field.checked && opts.parseBool){
					val = false;
				}
				else if(opts.parseBool && (val === 'true' || val === 'false')){
					val = (val === 'true');
				}
				else if(field.type === 'file') {
					let fileName = field.files[0];

					if(typeof fileName !== 'undefined') {
						asyncElems++;
						let reader = new FileReader();
						// eslint-disable-next-line no-loop-func
						reader.onload = function (e) {
							//params.logo_url = e.target.result;
							serialized[field.name] = e.target.result;
							asyncElems--;
							if(asyncElems === 0) {
								resolve(serialized);
							}
						};
						reader.readAsDataURL(fileName);
					}
				}

				if (!(opts.ignoreEmpty && val === '')) {
					let name = field.name.replace('[]', '');

					if(field.getAttribute('data-parse')) {
						switch(field.getAttribute('data-parse')) {
							case 'phone':
								val = val.replace(/\s/g,'');
								if(!val.startsWith('+')){
									if(val.startsWith('00')){
										val = val.replace('00', '+');
									}
									else if(val.startsWith('0')) {
										val = '+9' + val;
									}
									else {
										val = '+90' + val;
									}
								}
							break;
							case 'number':
								let decimalChar = field.getAttribute('data-parse-decimal-mark') ? field.getAttribute('data-parse-decimal-mark') : ',';
								val = stringToFloat(val, { decimalChar: decimalChar });
							break;
							default:
							break;
						}
					}

					if(name + '[]' === field.name){
						if (serialized[name]) {
							if(opts.multipleString) {
								val = serialized[name] += opts.multipleStringSeperator + val;
							}
							else {
								let nval = serialized[name]
								if(!Array.isArray(nval)){
									nval = [nval];
								}
								nval.push(val);
								val = nval;
							}
						}
						else { val = [val] }
					}
					serialized[name] = val;
				}
			}
		}
		
		if(asyncElems === 0) {
			resolve(serialized);
		}
	});

}

export default serializeObject